import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgComp = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#comp_svg__a)'>
      <path fill='#000' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#00D395'
        fillRule='evenodd'
        d='M6.932 16.024a1.21 1.21 0 0 1-.578-1.03v-2.345a.503.503 0 0 1 .758-.434l5.291 3.085c.31.18.5.511.5.87v2.429a.603.603 0 0 1-.919.516zm7.887-4.451c.31.18.499.512.5.87v4.93a.4.4 0 0 1-.205.35l-1.158.651a.2.2 0 0 1-.047.02v-2.738c0-.354-.186-.682-.49-.865l-4.647-2.779v-3.09a.503.503 0 0 1 .758-.434zm2.316-3.641c.31.18.501.512.501.871v7.2a.41.41 0 0 1-.212.354l-1.098.593v-5.012a1.01 1.01 0 0 0-.488-.864l-4.75-2.85v-2.93a.505.505 0 0 1 .756-.436z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='comp_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgComp)
export default ForwardRef
